let livemode=true;
let baseUrl='';
let logoUrl ='';
let Flagurl ='';
let KYCurl ='';

// Build-time override (CRA env): lets the same source build target the local
// test stack (REACT_APP_API_BASE_URL=http://localhost:8000/api/) or any other
// origin without editing this file.
if (process.env.REACT_APP_API_BASE_URL) {
    baseUrl = process.env.REACT_APP_API_BASE_URL;
} else if (livemode) {
    logoUrl ='https://cdn-courier-x.fniix.com/Logo/';
    Flagurl = 'https://cdn-courier-x.fniix.com/Flag/';
    KYCurl = 'https://cdn-courier-x.fniix.com/KYC/';
    
} else {
    baseUrl='http://192.168.29.182:8000/api/';
    logoUrl ='https://cdn-courier-x.fniix.com/Logo/';
    Flagurl = 'https://cdn-courier-x.fniix.com/Flag/';
    KYCurl = 'https://cdn-courier-x.fniix.com/KYC/';
}
let Global={
    baseUrl:baseUrl,
    logoUrl:logoUrl,
    flagurl:Flagurl,
    kyc:KYCurl,
    timezone:'Asia/Kolkata'
};
export default Global;